import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

//material ui components:
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';

//actions:
import { modifyFieldOtrosDatos } from '../../../actions/cierre_diario_actions';
import {  setSaveState } from '../../../actions';

//styles:
const styles = theme => ({
    checked: {
        color: theme.palette.secondary,
    },
    rightSide: {
        padding: 0,
        minHeight: "220px",
        marginBottom: '5px',
        fontSize: 13,
        fontWeight: '600',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
    },
    paperTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: '10%',
        fontSize: 13,
        fontWeight: '500',
        color: 'white',
        backgroundColor: theme.palette.secondary.main,
        padding: '4px 2px 4px 12px',
    },
    titleItem: {
        fontSize: 13,
        fontWeight: '500',
        color: 'white',
        display: 'flex',
        margin: 0,
    },
    containerItems: {
        margin: '1px auto'
    },
    itemContainer: {
        display: 'flex',
        padding: '2px 20px 2px 15px',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 12,
        minHeight: 40,  
    },
    radiobuttonContainer: {
        display: 'inline-flex',
        height: 0,
        marginTop: '-48px',
    }

});

class Operativa extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            //operativa:
            operativaRpta01: !this.props.otrosDatosCierreDiario.operativaRpta01 ? 0 : this.props.otrosDatosCierreDiario.operativaRpta01,
            operativaRpta02: !this.props.otrosDatosCierreDiario.operativaRpta02 ? 0 : this.props.otrosDatosCierreDiario.operativaRpta02,
            operativaRpta03: !this.props.otrosDatosCierreDiario.operativaRpta03 ? 0 : this.props.otrosDatosCierreDiario.operativaRpta03,
            operativaRpta04: !this.props.otrosDatosCierreDiario.operativaRpta04 ? 0 : this.props.otrosDatosCierreDiario.operativaRpta04,
            operativaRpta05: !this.props.otrosDatosCierreDiario.operativaRpta05 ? 0 : this.props.otrosDatosCierreDiario.operativaRpta05,
        };
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //once we get the data:
        if (prevProps.otrosDatosCierreDiario !== this.props.otrosDatosCierreDiario) {
            this.setState({
                //operativa:
                operativaRpta01: !this.props.otrosDatosCierreDiario.operativaRpta01 ? 0 : this.props.otrosDatosCierreDiario.operativaRpta01,
                operativaRpta02: !this.props.otrosDatosCierreDiario.operativaRpta02 ? 0 : this.props.otrosDatosCierreDiario.operativaRpta02,
                operativaRpta03: !this.props.otrosDatosCierreDiario.operativaRpta03 ? 0 : this.props.otrosDatosCierreDiario.operativaRpta03,
                operativaRpta04: !this.props.otrosDatosCierreDiario.operativaRpta04 ? 0 : this.props.otrosDatosCierreDiario.operativaRpta04,
                operativaRpta05: !this.props.otrosDatosCierreDiario.operativaRpta05 ? 0 : this.props.otrosDatosCierreDiario.operativaRpta05,
            });
        };
    };


    handleValueChange = (event, field) => {

        let value = event.target.value;

        if (value === 'true') value = true
        else if (value === 'false') value = false;

        this.setState({ ...this.state, [field]: value });

        this.props.setSaveState(true);
        this.props.modifyFieldOtrosDatos(field, value);
    };

    render() {

        const { classes } = this.props;


        const questions = [
            {
                value: this.state.operativaRpta01 ? 'true' : 'false',
                field: 'operativaRpta01',
                label: 'Planes de limpieza realizados'
            },
            {
                value: this.state.operativaRpta02 ? 'true' : 'false',
                field: 'operativaRpta02',
                label: 'Vitrinas rellenas'
            },
            {
                value: this.state.operativaRpta03 ? 'true' : 'false',
                field: 'operativaRpta03',
                label: 'Retornabolas vacío y limpio'
            },
            {
                value: this.state.operativaRpta04 ? 'true' : 'false',
                field: 'operativaRpta04',
                label: 'Accesorios OK en cada máquina'
            },
            {
                value: this.state.operativaRpta05 ? 'true' : 'false',
                field: 'operativaRpta05',
                label: 'Mistral-Bob-Gruas  rellenas'
            }
        ]

        return (
            <div style={{ margin: 0, marginBottom: 5 }}>
                <Paper className={classes.rightSide} elevation={0}>
                    <div className={classes.paperTitle}>
                        <h5 className={classes.titleItem}>BOWLING-REDEMPTION-ARCADE</h5>
                        <h5 className={classes.titleItem}>SÍ / NO</h5>
                    </div>
                    <Grid container className={classes.containerItems}>
                        {/* form container */}

                        {questions.map((q, i) =>
                            <Grid container className={classes.itemContainer} key={i}>
                                {/*label*/}
                                <Grid item xs={9}>
                                    <p style={{margin: '0 16px 0 0'}}>{q.label}</p>
                                </Grid>

                                <Grid item xs={3} className={classes.radiobuttonContainer}>
                                    <RadioGroup
                                        style={{ display: 'flex' }}
                                        value={q.value}
                                        onChange={(event) => this.handleValueChange(event, q.field)} >

                                        <FormControlLabel
                                            disabled={this.props.isDiaCerrado ? true : false}
                                            value={'true'}
                                            control={<Radio
                                                classes={{
                                                    checked: classes.checked,
                                                }} />}
                                        />

                                        <FormControlLabel
                                            disabled={this.props.isDiaCerrado ? true : false}
                                            value={'false'}
                                            control={<Radio
                                                classes={{
                                                    checked: classes.checked,
                                                }} />}
                                        />
                                    </RadioGroup>
                                </Grid>
                            </Grid>
                        )}

                    </Grid>
                    {/* end form container */}

                </Paper>
            </div>
        );
    };
};


Operativa.propTypes = {
    otrosDatosCierreDiario: PropTypes.object.isRequired,
    modifyFieldOtrosDatos: PropTypes.func.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
};


function mapStateToProps(state) {
    return {
        otrosDatosCierreDiario: state.otrosDatosCierreDiario.datos,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyFieldOtrosDatos,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(Operativa));